<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
        :title="title">
<!--        <template #right>-->
<!--            <bibles-filters>-->
<!--                <template #prepend>-->
<!--                    <div class="btns-cont">-->
<!--                        <SearchBar-->
<!--                            @search="(e)=>{searcher(e)}"-->
<!--                            @clear="(e)=>{searcher(e)}"-->
<!--                            :placeHolder="$t('indicators.search')"-->
<!--                        />-->
<!--                        <span>{{ search }}</span>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </bibles-filters>-->
<!--        </template>-->
        <template #right>
            <v-btn
                class="v-btn--primary ml-md-5 ml-sm-2"
                @click="dialogs.likert = true"
            >
                Likert
            </v-btn>
            <likert-dialog v-model="dialogs.likert"/>
        </template>
    </control-panel>
</template>

<script>
import ControlPanel from "@/Shared/ControlPanel";
import SearchBar from "@/Shared/Users/SearchBar";
import IndicatorsFilters from "./IndicatorsFilters.vue";
import LikertDialog from "@/Shared/Dialogs/LikertDialog";

export default {
    name: "IndicatorsHeader",

    components: {
        ControlPanel,
        SearchBar,
        IndicatorsFilters,
        LikertDialog,
    },

    props: {
        type: {
            type: Object,
        },
        title: '',
    },

    data() {
        return {
            breadcrumbsItems: [
                {
                    text: this.$t('app.sidebar_items.indicators'),
                    disabled: true,
                },
                {
                    text: this.$t('app.sidebar_items.list'),
                    disabled: false,
                    href: route('indicators.index'),
                },
                {
                    text: this.title,
                    disabled: true,
                },
            ],
            search:"",
            dialogs: {
                likert: false,
            },
        }
    },

    methods: {
        searcher(e){
                this.$emit("changeSearch",e)
            },
    }

}
</script>

<style scoped>

</style>
